// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { toast } from 'react-toastify';

// Internal Dependencies
import MText from '../../../../components/Common/MText';
import OverLoading from '../../../../components/Loading';
import MButton from '../../../../components/MButton';
import Colours from '../../../../styles/colours';
import ApiService from '../../../../services/apiService';

const DeleteModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const onDelete = async () => {
    try {
      setIsLoading(true);

      await ApiService.deletePromoCodes(props.pageId, { ids: props.selectedPromoCodes });

      toast.success('Promo codes deleted successfully');
      props.onComplete();
    } catch (error) {
      toast.error(error?.message || 'Failed to delete promo codes');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={props.open}
      fullWidth
    >
      <DialogTitle><MText size={14} text="Delete Confirmation" /></DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={props.onClose}>
          <Close />
        </IconButton>
      </Box>

      { isLoading && <OverLoading /> }

      <DialogContent>
        <MText size={13} bold>
          {props.selectedPromoCodes.length}
          {' '}
          Promo codes will be deleted. This action cannot be undone
        </MText>
      </DialogContent>

      <DialogActions className="pb-4 pr-3">
        <MButton onClick={props.onClose} text="Cancel" variant="outlined" />
        <MButton
          className="ml-4"
          onClick={onDelete}
          text="Delete"
          textColour={Colours.White}
          variant="outlined"
          colour={Colours.Secondary}
        />
      </DialogActions>
    </Dialog>
  );
};

DeleteModal.propTypes = {
  open:               PropTypes.bool.isRequired,
  pageId:             PropTypes.number.isRequired,
  selectedPromoCodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  onClose:    PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
};
export default DeleteModal;
